/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'quit': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M11 1h-1v10h1V1zM1 6.501h6.293L4.928 8.86l.708.707L9.208 6l-3.539-3.54-.707.707 2.331 2.333H1v1z" _fill="#0071B3"/><path pid="1" d="M11 1h-1v10h1V1zM1 6.501h6.293L4.928 8.86l.708.707L9.208 6l-3.539-3.54-.707.707 2.331 2.333H1v1z" _stroke="#0071B3"/>'
  }
})
